import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllAlertsServices = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const created_between = urlQueries["created_between"] || "";

  const allAlertServices = useQuery({
    queryKey: [
      ...CACHE_KEYS.ALERT,
      page,
      debouncedQuery,
      per_page,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.ALERT,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[created_between]": created_between,
          page: page,
          per_page: per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allAlertServices },
    states: { searchQuery, setSearchQuery },
  };
};
